import { InitialState } from './types';
import { initialState } from './reducer';

const DRAFT_KEY = 'logbook_case_draft';
const DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 hari

interface StoredDraft {
  savedAt: number;
  state: InitialState;
}

// Field yang selalu berbeda dari initialState walau user belum mengisi apa pun
const IGNORED_KEYS: (keyof InitialState)[] = ['date', 'caseType'];

const stripIgnored = (state: InitialState) => {
  const copy: Record<string, unknown> = { ...state };
  IGNORED_KEYS.forEach((k) => delete copy[k]);
  return JSON.stringify(copy);
};

export const isDraftEmpty = (state: InitialState) =>
  stripIgnored(state) === stripIgnored(initialState);

export const saveDraft = (state: InitialState) => {
  try {
    if (isDraftEmpty(state)) {
      localStorage.removeItem(DRAFT_KEY);
      return;
    }
    const payload: StoredDraft = { savedAt: Date.now(), state };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(payload));
  } catch {
    // localStorage tidak tersedia (private mode dll) - abaikan
  }
};

export const loadDraft = (caseType: string): InitialState | null => {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredDraft;
    if (!parsed?.state || parsed.state.caseType !== caseType) return null;
    if (Date.now() - parsed.savedAt > DRAFT_MAX_AGE_MS) {
      localStorage.removeItem(DRAFT_KEY);
      return null;
    }
    if (isDraftEmpty(parsed.state)) return null;
    return parsed.state;
  } catch {
    return null;
  }
};

export const clearDraft = () => {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // abaikan
  }
};
